module.exports = __webpack_public_path__ + "img/20171230_202320-min.741f3e11.jpg";